import React from 'react';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import SupplierCompanyFields from './SupplierCompanyFields';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import ManagerFields from '../../../../Dashboard/Contractors/SubComponents/ContractorCreateUpdateFlows/ManagerFields';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import SupplierSummary from './SupplierSummary';
import { STEPS_SUPPLIER_EMPLOYEE_FLOW_CREATE_WITHOUT_EXTRA_DATA } from '../../Model/Model';
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */

const EmployeeFlowSupplierCreateWithoutExtraData = ({
    steps,
    activeStep,
    setActiveStep,
    handleStepChange,
    user,
    setUser,
    emptyFields,
    resetForm,
    getAllServiceType,
    handleValidateSteps,
    photoPicker,
    setPhotoPicker,
    validateEmail,
    validatePhone,
    FormHandler,
    disabled,
    isValidDocumentId,
    setIsValidDocumentId,
    isValidEmail,
    isValidPhoneNumber,
    isValidDob,
    setIsValidDob,
    handleEmailChange,
    handlePhoneNumberChange,
    handleDateChange,
    userInfoStatusList,
    handlePasswordChange,
    headersList,
}) => {
    return (
        <StepperTabs
            id={null}
            steps={steps}
            activeStep={activeStep}
            isStepOptional={() => {}}
            setActiveStep={setActiveStep}
            handleStepChange={handleStepChange}
        >
            <StepTab
                index={STEPS_SUPPLIER_EMPLOYEE_FLOW_CREATE_WITHOUT_EXTRA_DATA.COMPANY_DETAILS}
                activeStep={activeStep}
                normalHeight
            >
                <>
                    <SupplierCompanyFields
                        user={user}
                        setUser={setUser}
                        emptyFields={emptyFields}
                        resetForm={() => resetForm(0)}
                        getAllServiceType={getAllServiceType}
                    />
                    <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                        <ButtonNextStep
                            id='btn_efs_next_manager_fields'
                            text='next'
                            click={() => {
                                if (handleValidateSteps(activeStep)) {
                                    setActiveStep((p) => p + 1);
                                }
                            }}
                        />
                    </div>
                </>
            </StepTab>
            <StepTab
                index={STEPS_SUPPLIER_EMPLOYEE_FLOW_CREATE_WITHOUT_EXTRA_DATA.MANAGER_DETAILS}
                activeStep={activeStep}
                normalHeight
            >
                <>
                    <ManagerFields
                        title='manager'
                        user={user}
                        setUser={setUser}
                        emptyFields={emptyFields}
                        isValidDocumentId={isValidDocumentId}
                        setIsValidDocumentId={setIsValidDocumentId}
                        isValidEmail={isValidEmail}
                        handlePasswordChange={handlePasswordChange}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        handleEmailChange={handleEmailChange}
                        handlePhoneNumberChange={handlePhoneNumberChange}
                        handleDateChange={handleDateChange}
                        statusList={userInfoStatusList}
                        handleClearAll={() => resetForm(activeStep)}
                    />

                    <div className='d-flex justify-content-between mt-3'>
                        <ButtonPrevStep
                            id='btn_efs_back_company_fields'
                            text='back'
                            click={() => setActiveStep((p) => p - 1)}
                        />
                        <ButtonNextStep
                            id='btn_efs_next_photo_profile'
                            text='next'
                            disabled={activeStep === steps.length - 1}
                            click={() => {
                                if (handleValidateSteps(activeStep)) {
                                    setActiveStep((prevStep) => prevStep + 1);
                                }
                            }}
                        />
                    </div>
                </>
            </StepTab>
            <StepTab
                index={STEPS_SUPPLIER_EMPLOYEE_FLOW_CREATE_WITHOUT_EXTRA_DATA.ADD_PHOTO}
                activeStep={activeStep}
                normalHeight
            >
                <>
                    <CustomPhotoPicker
                        id='fp_efs_photo_profile'
                        photoPicker={photoPicker}
                        setPhotoPicker={setPhotoPicker}
                        actionModel={ACTION_MODEL.CREATE}
                        accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                        showBtnCamera
                        validateFace
                        showPreview
                        disabled={disabled}
                        classWith={'content-center-w-400px'}
                        typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE}
                    />

                    <div className='d-flex justify-content-between mt-3'>
                        <ButtonPrevStep
                            id='btn_efs_back_manager_fields'
                            text='back'
                            click={() => setActiveStep((p) => p - 1)}
                        />
                        <ButtonNextStep
                            id='btn_efs_next_summary'
                            text='next'
                            click={() => setActiveStep((p) => p + 1)}
                        />
                    </div>
                </>
            </StepTab>
            <StepTab
                index={STEPS_SUPPLIER_EMPLOYEE_FLOW_CREATE_WITHOUT_EXTRA_DATA.SUMMARY}
                activeStep={activeStep}
                normalHeight
            >
                <>
                    <SupplierSummary
                        user={user}
                        photoPicker={photoPicker}
                        getAllServiceType={getAllServiceType}
                        extraDataEnabled={false}
                        headersList={headersList}
                    />

                    <div className='d-flex justify-content-between mt-3'>
                        <ButtonPrevStep
                            id='btn_efs_back_photo_profile'
                            text='back'
                            click={() => setActiveStep((p) => p - 1)}
                        />
                        <ButtonNextStep
                            id='btn_efs_create'
                            text='create'
                            click={() => {
                                validateEmail(user.email);
                                validatePhone(user.phoneNumber);
                                FormHandler();
                            }}
                        />
                    </div>
                </>
            </StepTab>
        </StepperTabs>
    );
};

export default EmployeeFlowSupplierCreateWithoutExtraData;
